import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'
import ArrowIcon from 'core/components/icons/ArrowIcon'

const PostList = props => {
  const { items } = props
  const q = new URLSearchParams(location.search)

  const arrow = (
    <span className="post-list-view-link type-body mod-md-body">
      View <ArrowIcon />
    </span>
  )

  return (
    <ul className="post-list">
      <li>
        <table className="post-table">
          <tbody>
            <tr className="post-table-row">
              <th
                id="name"
                style={{ width: '50%' }}
                className={`post-table-cell type-body mod-ui mod-sort ${
                  q.get('sort') === 'name' ? 'is-active' : ''
                }`}
                onClick={e => props.toggleSort(e)}
              >
                Name
                <span className={`post-table-order mod-${q.get('order')}`}></span>
              </th>

              <th
                id="type"
                style={{ width: '50%' }}
                className={`post-table-cell type-body mod-ui mod-sort ${
                  q.get('sort') === 'type' ? 'is-active' : ''
                }`}
                onClick={e => props.toggleSort(e)}
              >
                Type
                <span className={`post-table-order mod-${q.get('order')}`}></span>
                <button
                  className={`post-table-filter ${q.get('filter') === 'type' ? 'is-active' : ''}`}
                  onClick={e => props.toggleFilter(e)}
                ></button>
              </th>
            </tr>

            <tr className="post-table-row">
              <th
                id="location"
                style={{ width: '50%' }}
                className={`post-table-cell type-body mod-ui mod-sort ${
                  q.get('sort') === 'location' ? 'is-active' : ''
                }`}
                onClick={e => props.toggleSort(e)}
              >
                Location
                <span className={`post-table-order mod-${q.get('order')}`}></span>
                <button
                  className={`post-table-filter ${
                    q.get('filter') === 'location' ? 'is-active' : ''
                  }`}
                  onClick={e => props.toggleFilter(e)}
                ></button>
              </th>

              <th
                id="year"
                style={{ width: '50%' }}
                className={`post-table-cell type-body mod-ui mod-sort ${
                  q.get('sort') === 'year' ? 'is-active' : ''
                }`}
                onClick={e => props.toggleSort(e)}
              >
                Year
                <span className={`post-table-order mod-${q.get('order')}`}></span>
                <button
                  className={`post-table-filter ${q.get('filter') === 'year' ? 'is-active' : ''}`}
                  onClick={e => props.toggleFilter(e)}
                ></button>
              </th>
            </tr>
          </tbody>
        </table>
      </li>

      {items.map(item => (
        <li key={item.ID} className="post-list-item">
          {item.fields.redirect_url ? (
            <a
              href={item.fields.redirect_url}
              target="_blank"
              className="post-list-title type-heading mod-md-head"
            >
              {item.post_title}
              {arrow}
            </a>
          ) : (
            <Link
              to={`/project/${item.post_name}`}
              className="post-list-title type-heading mod-md-head"
            >
              {item.post_title}
              {arrow}
            </Link>
          )}

          <div className="post-list-meta type-body mod-md-body">
            {item.terms.project_type && (
              <p data-id="type" className="post-list-tag" onClick={e => props.toggleFilter(e)}>
                {item.terms.project_type[0].name}
              </p>
            )}
            {item.terms.project_location && (
              <p data-id="location" className="post-list-tag" onClick={e => props.toggleFilter(e)}>
                {item.terms.project_location[0].name}
              </p>
            )}
            <p data-id="year" className="post-list-tag" onClick={e => props.toggleFilter(e)}>
              {item.post_date.slice(0, 4)}
            </p>
          </div>
        </li>
      ))}
    </ul>
  )
}

PostList.propTypes = {
  items: PropTypes.array.isRequired,
  toggleFilter: PropTypes.func,
  toggleSort: PropTypes.func
}

export default PostList
